import { FC } from 'react';
import ReactDOM from 'react-dom';

type Props = {
  portalIndex: number;
};

const ALLOWED_ROUTES = [Routes.artworks_path(), Routes.artists_path()];

export const MenuItemPortal: FC<Props> = ({ children, portalIndex = 0 }) => {
  const { pathname } = location;

  const container = document.querySelectorAll('.navigation-menu__item.js-menu-item-portal')[
    portalIndex
  ];

  if (!container || !ALLOWED_ROUTES.includes(pathname)) {
    return null;
  }

  container.innerHTML = '';

  return ReactDOM.createPortal(children, container);
};
